import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const LazyProvidersConfiguration = lazy(() =>
  import(/* webpackChunkName: 'CompaniesConfiguration' */ './index'),
);

export default function CompaniesConfiguration(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyProvidersConfiguration {...props} />
    </Suspense>
  );
}
